interface Props {
  isDraft: boolean;
}

export default function DraftIndicator({ isDraft }: Props) {
  const isStaging = process.env.NEXT_PUBLIC_ENABLE_DRAFT_MODE === 'true';

  if (!isStaging || !isDraft) return null;

  return (
    <div className="bg-yellow-100 border-l-4 border-yellow-500 p-4 mb-6">
      <p className="text-yellow-700 font-medium">
        📝 Draft Preview - This post is not yet published
      </p>
    </div>
  );
}
